import '.hu{height:72px;}.ssr-plugin'
import '.r{flex:1;}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import '.ao{cursor:pointer;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a2{border:none;}.ssr-plugin'
import '.b9{appearance:none;}.ssr-plugin'
import '.an{background:transparent;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { capitalize, splitByUppercase } from '../../utils/text.js'
import { Icon, IconProps } from '../Icon/index.js'
import { Overlay } from '../Overlay/index.js'
import { Text } from '../Text/index.js'
import { styled } from 'inlines'

type OptionCardGroupProps = {
  value: string
  onChange: (value: string) => void
  keepOpenOnClick?: boolean
  options: {
    label?: string
    value: string
    icon: IconProps['variant']
    disabled?: boolean
  }[]
}

function OptionCardGroup({
  value,
  onChange,
  options,
  keepOpenOnClick = true,
}: OptionCardGroupProps) {
  return (
    <fieldset
      style={{
        appearance: 'none',
        border: 'none',
        padding: 0,
        display: 'flex',
        gap: 4,
        ...(options.length > 3 && {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        }),
      }}
    >
      {options.map((option, index) => (
        <styled.label className="hu r a8 ao a i c d a2 b9 an"
          key={index}
          data-selected={option.value === value ? true : undefined}
          data-disabled={option.disabled ? true : undefined}
          style={{
            borderRadius: radius[12],
            color: colors.neutral80,
            '&:hover:not([data-disabled])': {
              color: colors.neutral100,
              background: colors.neutral10Adjusted,
            },
            '&:has(:focus-visible):not([data-disabled])': {
              outlineWidth: 4,
              outlineStyle: 'solid',
              outlineColor: colors.neutral20,
            },
            '&[data-selected]': {
              color: colors.neutral100,
              background: colors.neutral10Adjusted,
            },
            '&[data-selected]:hover:not([data-disabled])': {
              background: colors.neutral20Adjusted,
            },
            '&[data-disabled]': {
              color: colors.neutral20,
              cursor: 'not-allowed',
            },
          }}
        >
          <Icon variant={option.icon} />
          <Text variant="display-medium" color="inherit">
            {option?.label ?? capitalize(splitByUppercase(option.value))}
          </Text>
          <input
            style={{
              position: 'absolute',
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              whiteSpace: 'nowrap',
              borderWidth: 0,
            }}
            type="radio"
            checked={option.value === value}
            onChange={() => {
              if (!keepOpenOnClick) {
                Overlay.CloseAll()
              }
              onChange(option.value)
            }}
            disabled={option.disabled}
          />
        </styled.label>
      ))}
    </fieldset>
  )
}

export type { OptionCardGroupProps }
export { OptionCardGroup }
